import request from '@/utils/request'

export default {
  // 商圈列表
  businessDistrictListByIds (query) {
    return request({
      url: `/businessDistrict/getBusinessDistrict`,
      method: 'get',
      params: query
    })
  },
  // 街道列表
  streetListByIds (query) {
    return request({
      url: `/street/getStreet`,
      method: 'get',
      params: query
    })
  },

  businessDistrictListByIdsV2 (data) {
    return request({
      url: `/businessDistrict/getBusinessDistrictList`,
      method: 'post',
      data: data
    })
  },

  streetListByIdsV2 (data) {
    return request({
      url: `/street/getStreetList`,
      method: 'post',
      data: data
    })
  }
}
